"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Action = void 0;
class Action {
    constructor(name, _channelName, _logger) {
        this.name = name;
        this._channelName = _channelName;
        this._logger = _logger;
        this._resolver = null;
        this._header = undefined;
        this.publishFormatter = (publishObj) => {
            const { channel, data, error, header, topic } = publishObj;
            return `   
        ACTION: EXECUTE
        CHANNEL: ${channel}
        TOPIC: ${topic}
        HEADER: ${JSON.stringify(header)}
        DATA: ${(data && JSON.stringify(data)) || 'No data.'}
        ERROR: ${error || 'No errors.'}
        TIMESTAMP: ${new Date()}
        `;
        };
    }
    get hasRegisteredResolver() {
        return Boolean(this._resolver);
    }
    registerResolver(resolver, header) {
        var _a, _b;
        if (!resolver) {
            throw new Error('resolver parameter is mandatory');
        }
        if (this._resolver) {
            const publisher = (_b = (_a = this._header) === null || _a === void 0 ? void 0 : _a.publisher) !== null && _b !== void 0 ? _b : undefined;
            throw new Error(`Topic ${this.name} is a single subscribe topic and there is already one subscriber. publsiher: ${publisher}`);
        }
        this._resolver = resolver;
        this._header = header;
        return {
            unsubscribe: () => {
                this._resolver = null;
                this._header = undefined;
            },
        };
    }
    execute(payload, header) {
        if (!this._resolver) {
            throw new Error(`There is no resolver registered for action ${this.name} in channel ${this._channelName}`);
        }
        this._logger.debug(this.publishFormatter({
            channel: this._channelName,
            data: payload,
            error: null,
            header,
            topic: this.name,
        }));
        return this._resolver(payload, header);
    }
}
exports.Action = Action;
//# sourceMappingURL=action.js.map